import { useMemo } from 'react'
import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { OrgId } from 'app/common/types/id'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle } from './helpers'

export const OrgControl = () => {
  const id = useFilter('orgId')
  const years = useFilterOptions('orgs')
  const loading = useFilterOptionsLoadingByKey('orgs')

  const selection = useMemo(() => (id.draft ? [id.draft] : []), [id.draft])
  const defaultSelection = useMemo(() => (id.default ? [id.default] : []), [id.default])

  return (
    <PlainItemsSelector
      id="org"
      label="Учебное заведение"
      header="Выбор учебного заведения"
      pleaseSelectText="Все"
      items={years}
      selection={selection}
      defaultSelection={defaultSelection}
      onChange={([selected]) => filterActions.selectDraftOrg(selected as OrgId | undefined)}
      loading={loading}
      sortFunc={sortByTitle}
      selectedAllOnEmptySelection={false}
      skipUpperSpace
      alwaysAutoSelect
    />
  )
}
